import { createModal } from "@commonlibs";
import clsx from "clsx";
import Modal from "ui/common/components/feedback/Modal/Modal";
import { OTPModalProps } from "./OTPModal.types";
import OTPForm from "../../OtpForm/OtpForm";

const OtpModal = createModal(
    ({ className, action, actionArgs, isLoading, onSuccess, onSubmit, onInvalid, onRegenerateOtp, ...rest }: OTPModalProps) => {
        return (
            <Modal className={clsx("redeem-pints-modal", className)} {...rest} style={{ maxWidth: "560px" }}>
                <OTPForm
                    onSuccess={onSuccess}
                    isLoading={isLoading}
                    action={action}
                    actionArgs={actionArgs}
                    onOTPCodeValidated={onSubmit}
                    onOTPCodeInvalidated={onInvalid}
                    onRegenerateOtp={onRegenerateOtp}
                />
            </Modal>
        );
    },
);

export default OtpModal;
